import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M3.5 20.5H11.5V19.5C11.5 17.8431 10.1569 16.5 8.5 16.5H6.5C4.84315 16.5 3.5 17.8431 3.5 19.5V20.5ZM7.55714 16.5V16.5C9.1351 16.5 10.4143 15.2208 10.4143 13.6429V13.3571C10.4143 11.7792 9.1351 10.5 7.55714 10.5V10.5C5.97919 10.5 4.7 11.7792 4.7 13.3571L4.7 13.6429C4.7 15.2208 5.97919 16.5 7.55714 16.5Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
        />
        <path
            d="M13.5 13.5H21.5V12.5C21.5 10.8431 20.1569 9.5 18.5 9.5H16.5C14.8431 9.5 13.5 10.8431 13.5 12.5V13.5ZM17.5571 9.5V9.5C19.1351 9.5 20.4143 8.22081 20.4143 6.64286V6.35714C20.4143 4.77919 19.1351 3.5 17.5571 3.5V3.5C15.9792 3.5 14.7 4.77919 14.7 6.35714L14.7 6.64286C14.7 8.22081 15.9792 9.5 17.5571 9.5Z"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
        />
    </svg>
);

export default Icon;
